import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import {
  generateDateRanges,
  label,
} from 'modules/performance_analytics/components/PerformanceInsightsSummaryDatatable/filters/tenureDateFilter'

import { useFilter, useNewlyAddedFilters } from '../context'

export const TenureFilter = () => {
  const { value, setValue } = useFilter('tenureDates')
  const { newlyAddedFilters } = useNewlyAddedFilters()

  const options: { label: string; value: string }[] = generateDateRanges().map((dates, i) => ({
    label: label(i),
    value: dates.join('#'),
  }))

  if (options.length === 0) return null

  return (
    <Filter.MultipleChoice
      label={i18n.t('performance_process.reviews.filters.tenure')}
      value={value}
      options={options}
      onValueChange={(newValue) => setValue(newValue ?? [])}
      defaultOpen={newlyAddedFilters.includes('tenureDates')}
    />
  )
}
